import { axiosInstance } from '../../../util/axios/instance.axios'
import { CertificationListResponse, CertificationResponse, CreateCertificationDto } from '../model/certification'

export async function getCertifications(userId?: string): Promise<CertificationListResponse> {
  const { data } = await axiosInstance.request<CertificationListResponse>({
    url: '/profile/certifications-list',
    params: { userId },
  })
  
  return data
}

export async function createCertification(dto: CreateCertificationDto): Promise<CertificationResponse> {
  const { data } = await axiosInstance.request<CertificationResponse>({
    url: '/profile/save-certifications',
    method: 'POST',
    data: dto,
  })
  
  return data
}

export async function deleteCertification(id: string): Promise<void> {
  await axiosInstance.request({
    url: `/profile/delete-certifications/${id}`,
    method: 'DELETE',
  })
}

export async function getEducationAndCompetencies(): Promise<string[]> {
  const { data } = await axiosInstance.request<{ educationAndCompetencies: string }>({
    url: '/profile/education-competencies',
  })
  
  if (!data.educationAndCompetencies) {
    return []
  }
  
  return data.educationAndCompetencies
    .split(',')
    .map(item => item.trim())
    .filter(item => item.length > 0)
}